// type: functions
// description: Fonctions pour initialiser les listeners internes

import JsEvent from '@rotomeca/event';
import {
  EventSelectArgs,
  HTMLBnumSegmentedItem,
  OnSelectCallback,
} from '../bnum-segmented-item.internal';

/**
 * Interface mapping the protected members needed for internal wiring.
 */
interface BnumSegmentedItemInternal {
  _p_onSelectedTrigger(event: Event): void;
}

export function OnSelectListenerInitializer(
  listener: JsEvent<OnSelectCallback>,
  instance: HTMLBnumSegmentedItem,
): void {
  listener.add('default', (args: EventSelectArgs) => {
    (instance as unknown as BnumSegmentedItemInternal)._p_onSelectedTrigger(
      args.parentEvent ?? new Event('click'),
    );
  });
}
